import { Roi, ChangeProjectionService } from '@analysis/domain';
import { type RoiRepository, type RoiChangesRepository } from '../../ports';

export interface GetRoiDetailsPayload {
  roiId: string;
  signal?: AbortSignal;
}

export class GetRoiDetailsUseCase {
  constructor(private readonly rois: RoiRepository, private readonly changes: RoiChangesRepository) {}

  public async execute(input: Readonly<GetRoiDetailsPayload>): Promise<Roi | null> {
    const { roiId, signal } = input;

    const result = await this.rois.getById(roiId, signal);

    if (!result) return null;

    const changesMap = await this.changes.getByIds([result.id]);
    const change = changesMap.get(result.id);

    if (!change) return result;

    if (change.isNew && change.snapshot) return change.snapshot;

    return ChangeProjectionService.applyChanges(result, change);
  }
}
